export default __webpack_public_path__ + "static/media/Bitmap(3).c3b95da1.png";